import React, {Fragment} from 'react'
import Map from "../../../../Components/GoogleMaps/Mapa";
export default function Tracking(props) {
    return (
        <table className='OrderBuy-traking'>
            <thead>
                <tr>
                    <td colSpan={3}>Seguimiento de Paquete</td>
                </tr>
                <tr>
                    <td>mmsi</td>

                    <td colSpan={2}>Ship</td>
                    
                </tr>
            </thead>
            <tbody>
                {
                        props.Vessel.map((ves, ives) => (
                            <Fragment key={ives}>
                                <tr>
                                    <td>{ves.mmsi}</td>

                                    <td colSpan={2}>{ves.name}</td>
                                    
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <Map
                                            style={{ width: '100%', height: '350px' }}
                                            center={{ lat: parseFloat(ves.lat), lng: parseFloat(ves.lng) }}
                                            zoom={2}
                                            marks={[
                                                {
                                                    pos: { lat: parseFloat(ves.lat), lng: parseFloat(ves.lng) },
                                                }
                                            ]} />
                                    </td>
                                </tr>
                            </Fragment>
                        ))
                }

                <tr>
                    <td colSpan={3}>
                        <table className='OrderBuy-history'>
                            <thead>
                                <tr>
                                    <td colSpan={3}>
                                        Historial de Rastreo
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fecha</td>
                                    <td>Evento</td>
                                    <td>Descripcion</td>
                                </tr>
                            </thead>
                            <tbody>
                                {props.children}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

    )
}
